











































































import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import BaseVue from "@/core/BaseVue";
import TipoTramiteComponentProp from "@/helpers/tipoTramiteComponentProp.helper";
import { PropOptions } from "vue";
import Miembro from "../../models/miembro/miembro.model";
import BTableConfig from "@/core/BTableConfig/BTableConfig";
import { RowTable } from "@/typings/BRowTable";
import Helpers from "@/helpers/helper";
import Persona from "../../models/persona/persona.model";
import Beneficiario from "@/models/beneficiario/beneficiario.model";
import TramiteBeneficiario from "@/models/tramite/tramiteBeneficiario.model";
import SolicitudReemplazoPorCorreccion, {
  SolicitudReemplazoPorCorreccionDocumento
} from "@/models/tramite/reemplazos/solicitud-reemplazo-correccion-jefe.model";
import { Utils } from "@/core/Utils";
import BaseRepository from "@/core/HttpResources/BaseRepository";
import NameValue from "@/models/nameValue.model";
import TipoTramite from "@/models/tipoTramite";
@Component
export default class SolicitudReemplazoPorCorreccionComponent extends BaseVue {
  @Prop() readonly tipoTramite!: TipoTramite;
  @Prop() readonly solicitante!: Persona;
  @Prop() readonly beneficiario!: Beneficiario;
  @Prop() readonly content!: TramiteBeneficiario;
  @Prop() readonly codigoDocAdicionales!: string;

  editing = false;
  personaTest = new Persona();
  miembroInitial: Miembro | null = null;
  miembroModel: Miembro | null = null;
  miembroToSave: Miembro | null = null;
  nameValue = new NameValue();
  model = new SolicitudReemplazoPorCorreccion();
  constructor() {
    super();
  }
  get hogarId() {
    if (this.beneficiario && this.beneficiario.hogarId) {
      return this.beneficiario.hogarId;
    }
    return 0;
  }
  get hogarCode() {
    if (this.beneficiario && this.beneficiario.codigoHogar)
      return this.beneficiario.codigoHogar;
    return "";
  }
  loadingMiembro = false;
  async requestMiembro() {
    this.loadingMiembro = true;
    let result = await new BaseRepository<Miembro>("miembro").one(
      `personaId="${this.beneficiario.personaId}"`,
      "Persona"
    );
    this.miembroInitial = result;
    this.miembroModel = result;
    this.loadingMiembro = false;
  }
  created() {
    let props = [];
    props.push(
      new TipoTramiteComponentProp(
        "codigoDocAdicionales",
        "string",
        true,
        "Código de docs. adicionales"
      )
    );
    this.$emit("render", props);
  }

  destroyed() {
    if (this.content) {
      let contenido = this.content as any;
      if (contenido.solicitudReemplazoPorCorreccion)
        delete contenido.solicitudReemplazoPorCorreccion;

      this.$emit("update:content", contenido);
    }
  }
  mapModel(obj: any) {
    let m = this.map<Miembro>(obj);
    let p = m.persona as Persona;
    (m.persona as Persona).nombreCompleto = `${p.nombre1} ${p.nombre2} ${p.apellido1} ${p.apellido2}`;
    return m;
  }

  showModalEditMiembro(row: Miembro) {
    this.miembroModel = this.mapModel(row);
    this.editing = true;
  }
  editModelChange(value: Miembro) {
    this.miembroToSave = value;
  }

  getMember(m: any) {
    let val = new SolicitudReemplazoPorCorreccion(
      this.hogarId,
      m.id,
      m.personaId
    );
    if (m.persona) {
      let ignore = [
        "id",
        "deleted",
        "createdDate",
        "updatedDate",
        "createdBy",
        "updatedBy",
        "cedula",
        "fechaNacimiento",
        "documentos"
      ];
      Utils.mapToObject(m.persona, val, { ignore: ignore });
      if (m.persona.cedulaPadre)
        val.cedulaPadre = m.persona.cedulaPadre.replace(/-/g, "");
      if (m.persona.cedulaMadre)
        val.cedulaMadre = m.persona.cedulaMadre.replace(/-/g, "");
      if (m.persona.telefono)
        val.telefono = Helpers.Filters.PhoneToStr(m.persona.telefono);

      if (m.persona.estaEstudiando) m.persona.ultimoNivelAcademico = "";
      else if (m.persona.estaEstudiando === false) {
        m.persona.centroAcademicoId = undefined;
        m.persona.centroAcademicoOtro = "";
        m.persona.cursoEstudiante = "";
      }

      if (m.persona.cedula) val.cedula = m.persona.cedula.replace(/-/g, "");
      else val.cedula = undefined;
      if (m.persona.fechaNacimiento)
        val.fechaNacimiento = new Date(m.persona.fechaNacimiento.toString());
    }
    val.codHogar = m.codigoHogar;
    val.parentescoId = m.parentescoId;
    val.parentescoNombre = m.parentescoNombre;
    val.persona = m.persona;
    val.miembroId = m.id || m.miembroId;
    return val;
  }
  restartEdit() {
    this.miembroModel = this.mapModel(this.miembroInitial);
  }
  closeEdit() {
    this.editing = false;
    this.miembroModel = this.mapModel(this.miembroToSave);
  }
  async onSaveEdit() {
    this.miembroModel = this.mapModel(this.miembroToSave);
    this.emitChanges();
    this.editing = false;
  }

  emitChanges() {
    this.model = this.getMember(this.miembroModel)
    let contenido = this.content as any;
    if (contenido) {
      contenido.solicitudReemplazoPorCorreccion = this.map(this.model);
      this.$emit("update:content", contenido);
    }
  }
  @Watch("beneficiario", { immediate: true, deep: true })
  beneficiarioChange(model: Beneficiario) {
    this.requestMiembro().then(x => {
      this.emitChanges();
    });
  }
  onChangeDocs(tipos: any, docs: any[]) {
    this.model.documentos = docs.map(x => {
      let doc = new SolicitudReemplazoPorCorreccionDocumento();
      doc.personaId = this.model.personaId;
      doc.documentoId = x.documentoId;
      doc.documento = x.documento;
      doc.tipoDocumentoId = x.tipoDocumentoId;
      doc.tipoDocumentoNombre = x.tipoDocumentoNombre;
      return doc;
    });
    let contenido = this.content as any;
    if (contenido) {
      contenido.solicitudReemplazoPorCorreccion = this.map(this.model);
      this.$emit("update:content", contenido);
    }
  }
  @Watch("codigoDocAdicionales", { immediate: true })
  async onCodigoDocAdicionalesChange(value: string) {
    if (value) {
      this.nameValue = await new BaseRepository<NameValue>("namevalues").one(
        `codigo="${value}"`
      );
    }
  }

  public async isValid() {
    let isValid = await this.validateCurrentValidator();
    if (!isValid) return false;

    return this.validateRefCollection("documentos");
  }
}
